import { Injectable } from "@angular/core";
import {  Headers } from "@angular/http";
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';
import { HttpClientModule, HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable()
export class CertificadosService {
    [x: string]: any;

    public url;
    public identity;
    public token;
    constructor(private _http: HttpClient) {
        this.url = GLOBAL.url;
    }

    getPasos() {
        return this._http.get("assets/json/pasos_cert.json")
        .pipe(map((response: any) => response));    
    }


    getSolicitante(rut) {
        let params = {
            rut: rut
        };

        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'get/solicitante', params, { headers: headers })
        .pipe(map((response: any) => response));        }

    saveSolicitante(user) {
        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/solicitante', user, { headers: headers })
        .pipe(map((response: any) => response));        }

    getRol(rol) {
        let params = {
            rol: rol
        };

        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'get/rol', params, { headers: headers })
        .pipe(map((response: any) => response));        }

    getPropiedades(rol?, id?, dir?, num?) {
        var params;

        if (rol && dir == undefined && num == undefined) {
            params = {
                rol: rol,
                id: id
            }
        }
        if (dir && num && rol == undefined) {
            params = {
                dir: dir,
                num: num
            }
        }
        console.log("params", params)
        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'get/propiedades', params, { headers: headers })
        .pipe(map((response: any) => response));        }

    savePropiedades(rol) {
        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/propiedades', rol, { headers: headers })
        .pipe(map((response: any) => response));        }

    getTipo_cert() {
        let params = {};
        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'get/tipos_certificados', params, { headers: headers })
        .pipe(map((response: any) => response));        }

    getCorviFM() {
        let params = {};
        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })
        

        return this._http.post(this.url + 'get/corvi', params, { headers: headers })
        .pipe(map((response: any) => response));        }

}